export default "skymp5-front/196868d324e3b4d2353891819b420d46.gif";